import type { ToolMeta } from './registry';

export const findGuestsMeta = {
  description:
    "Find the couple's guests by name, RSVP or category in their app, as {id, name, rsvp} — for the ids of guests to act on.",
  examples: ['Remove Anna Nowak from my guest list', 'Who has not replied yet?'],
  value: 'the guests on their list, found by name',
} as const satisfies ToolMeta;
